var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconChristmasTreeRegular = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.76 3.374A.953.953 0 0 0 13 3a.953.953 0 0 0-.76.374l-5.555 7.134a.97.97 0 0 0-.105 1.017.96.96 0 0 0 .868.542h.663l-2.7 4.037a.96.96 0 0 0-.048.989c.169.313.494.51.852.51h.96l-3.009 4.463a.959.959 0 0 0-.052.992c.169.314.494.51.851.51h16.07a.967.967 0 0 0 .851-.51.959.959 0 0 0-.052-.992l-3.009-4.463h.964a.967.967 0 0 0 .852-.51.96.96 0 0 0-.048-.989l-2.704-4.041h.663a.965.965 0 0 0 .763-1.559l-5.556-7.13zm-3.845 6.76H9.42L13 5.535l3.58 4.6h-.495a.967.967 0 0 0-.851.51.96.96 0 0 0 .048.99l2.7 4.04h-.973a.967.967 0 0 0-.851.51.959.959 0 0 0 .052.993l3.013 4.463H6.777l3.01-4.463c.2-.297.22-.679.051-.992a.967.967 0 0 0-.851-.51h-.972l2.7-4.042a.96.96 0 0 0 .047-.988.967.967 0 0 0-.851-.51h.004zm1.478 5.4a.964.964 0 1 0 0-1.928.964.964 0 0 0 0 1.928zm3.214-6.106a.964.964 0 1 0-1.928 0 .964.964 0 0 0 1.928 0zm.964 11.248a.964.964 0 1 0 0-1.928.964.964 0 0 0 0 1.928z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconChristmasTreeRegular, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-christmas-tree-regular.e1bd456f.svg";
export { ForwardRef as ReactComponent };